export default __webpack_public_path__ + "dda347c275c117fbb74d305148a473f9.png";